export default "__VITE_ASSET__C3uQNyh8__"